export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/greenBill.a7430e88.svg","height":145,"width":144,"blurWidth":0,"blurHeight":0};